import React, { useState, useEffect } from 'react';
import '../scss/playerRatings.scss';

const PlayerRatings = ({ ratings }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Small delay before starting animation
    const timer = setTimeout(() => {
      setIsAnimating(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const currentStats = {
    pace: ratings.pace || 0,
    shooting: ratings.shooting || 0,
    passing: ratings.passing || 0,
    dribbling: ratings.dribbling || 0,
    defending: ratings.defending || 0,
    physical: ratings.physical || 0
  };

  // Calculate positions for hexagon points
  const calculatePoint = (value, index, total = 6) => {
    const angle = (Math.PI * 2 * index) / total - Math.PI / 2;
    const radius = (value / 100) * 50; // 50 is the max radius
    return {
      x: 50 + radius * Math.cos(angle),
      y: 50 + radius * Math.sin(angle)
    };
  };

  // Generate points for the polygon
  const points = [
    calculatePoint(currentStats.pace, 0),
    calculatePoint(currentStats.shooting, 1),
    calculatePoint(currentStats.passing, 2),
    calculatePoint(currentStats.physical, 3),
    calculatePoint(currentStats.defending, 4),
    calculatePoint(currentStats.dribbling, 5),
  ];

  const polygonPoints = points.map(p => `${p.x},${p.y}`).join(' ');

  return (
    <div className="player-ratings">
      <div className="ratings-hexagon">
        <svg viewBox="0 0 100 100" className="ratings-chart">
          {/* Background grid */}
          <g className="grid">
            {[20, 40, 60, 80, 100].map((percent, i) => (
              <polygon
                key={i}
                points={[0, 1, 2, 3, 4, 5].map(j => {
                  const p = calculatePoint(percent, j);
                  return `${p.x},${p.y}`;
                }).join(' ')}
                className="grid-line"
              />
            ))}
          </g>
          
          {/* Stats polygon */}
          <polygon 
            points={polygonPoints} 
            className={`stats-polygon ${isAnimating ? 'animate' : ''}`} 
          />
          
          {/* Stat points */}
          {points.map((point, i) => (
            <circle
              key={i}
              cx={point.x}
              cy={point.y}
              r="2"
              className={`stat-point ${isAnimating ? 'animate' : ''}`}
            />
          ))}
        </svg>
        
        {/* Labels */}
        <div className="stat-label pace">PAC</div>
        <div className="stat-label shooting">SHO</div>
        <div className="stat-label passing">PAS</div>
        <div className="stat-label physical">PHY</div>
        <div className="stat-label defending">DEF</div>
        <div className="stat-label dribbling">DRI</div>
      </div>
    </div>
  );
};

export default PlayerRatings; 